import {StyleSheet} from '@react-pdf/renderer';

import {sharedStyles} from './shared-styles';
import {greenColors, orangeColors} from '../../../../../../layouts/theme/designSystem';

export const deepDiveStyles = StyleSheet.create({
  container: {
    padding: 12,
    backgroundColor: `${orangeColors[5]}`,
    border: `1 solid ${orangeColors[4]}`,
    borderRadius: '8px',
  },
  primaryText: {
    ...sharedStyles.h4,
    fontWeight: 'bold',
    lineHeight: 1.5,
  },
  secondaryText: {
    ...sharedStyles.h4,
    color: `${greenColors[700]}`,
    lineHeight: 1.5,
  },
});
